import { render, staticRenderFns } from "./order-form-properties-for-repair.vue?vue&type=template&id=178224c4&scoped=true"
import script from "./order-form-properties-for-repair.vue?vue&type=script&lang=js"
export * from "./order-form-properties-for-repair.vue?vue&type=script&lang=js"
import style0 from "./order-form-properties-for-repair.vue?vue&type=style&index=0&id=178224c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178224c4",
  null
  
)

export default component.exports